import axios from 'axios';

import errorHandlerInterceptor from './errorHandlerInterceptor';
import { refreshTokenInterceptor } from './API/refreshTokenInterceptor';
import { backendUnavailableInterceptor } from './API/backendUnavailableInterceptor';
import authInterceptor from './authInterceptor';

const axiosInstance = function () {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.response.use(
    (response) => response,
    refreshTokenInterceptor(axiosInstance),
  );
  axiosInstance.interceptors.response.use(
    (response) => response,
    backendUnavailableInterceptor(axiosInstance),
  );
  axiosInstance.interceptors.response.use(
    (response) => response,
    errorHandlerInterceptor(axiosInstance),
  );

  axiosInstance.interceptors.request.use(authInterceptor);

  return axiosInstance;
};
export default axiosInstance();
